<ng-container *ngIf="criteriaMap.size === 0; else hasFilters">
  <ng-container *ngIf="getScreenWidth > 808; then legendText; else legendTooltip"></ng-container>
  <ng-template #legendText>
    <div class="is-flex is-align-items-center is-justify-content-flex-end">
      <span i18n class="tag is-success is-bold mr-2">Editable</span>
      <span i18n class="tag is-warning is-bold">Not Editable</span>
    </div>
  </ng-template>
  <ng-template #legendTooltip>
    <div class="is-flex is-align-items-center is-justify-content-flex-end">
      <span i18n [attr.data-tooltip]="'Editable'" class="tooltip has-tooltip-top">
        <span class="fa-stack">
          <i class="fas fa-circle fa-stack-2x has-text-success"></i>
          <i class="fas fa-pencil fa-stack-1x has-text-white"></i>
        </span>
      </span>
      <span i18n [attr.data-tooltip]="'Not Editable'" class="tooltip has-tooltip-top">
        <span class="fa-stack">
          <i class="fas fa-circle fa-stack-2x has-text-warning"></i>
          <i class="fas fa-times fa-stack-1x"></i>
        </span>
      </span>
    </div>
  </ng-template>
</ng-container>

<ng-template #hasFilters>
  <ng-container
    *ngIf="
      (criteriaMap.has('startTime') && getScreenWidth > 1102) ||
        (!criteriaMap.has('startTime') && getScreenWidth > 940);
      then legendText;
      else legendTooltip
    "
  >
  </ng-container>
  <ng-template #legendText>
    <div class="is-flex is-align-items-center is-justify-content-flex-end">
      <span i18n class="tag is-success is-bold mr-2">Editable</span>
      <span i18n class="tag is-warning">Not Editable</span>
    </div>
  </ng-template>
  <ng-template #legendTooltip>
    <div class="is-flex is-align-items-center is-justify-content-flex-end">
      <span i18n [attr.data-tooltip]="'Editable'" class="tooltip has-tooltip-top">
        <span class="fa-stack">
          <i class="fas fa-circle fa-stack-2x has-text-success"></i>
          <i class="fas fa-pencil fa-stack-1x has-text-white"></i>
        </span>
      </span>
      <span i18n [attr.data-tooltip]="'Not Editable'" class="tooltip has-tooltip-top">
        <span class="fa-stack">
          <i class="fas fa-circle fa-stack-2x has-text-warning"></i>
          <i class="fas fa-times fa-stack-1x"></i>
        </span>
      </span>
    </div>
  </ng-template>
</ng-template>
